import React from "react";
import { GatsbyImage, GatsbyImageProps } from "gatsby-plugin-image";

export default function Image(props: GatsbyImageProps) {
  if (!props.image) {
    return <span className="gatsby-image-error" />;
  }
  return <GatsbyImage {...props} />;
}
